import { Accordion } from '../../../../../components/general/accordion';
import InfoIcon from '@mui/icons-material/Info';
import { TitleV1 } from '../../../../../components/titleV1';
import LoadingButtonGeneral from '../../../../../components/general/buttons/loadingButtonGeneral';
import SearchIcon from '@mui/icons-material/Search';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CASES_GENERAL_INFORMATION } from '../../../../../../routes/paths';
import { CasesGeneralInformationForm } from '../../../casesGeneralInformation/form';
import { AccountRegisterCasesGeneralInformationFormProps } from './props';

export const AccountRegisterCasesGeneralInformationForm = ({
    isOpen,
    account,
}: AccountRegisterCasesGeneralInformationFormProps) => {
    const navigate = useNavigate();

    return (
        <Accordion
            title="REGISTRO CASO INFORMACIÓN GENERAL"
            icon={<InfoIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={isOpen}
            mt={0}
            padding={0}
        >
            <TitleV1 title="CASO INFORMACIÓN GENERAL">
                <LoadingButtonGeneral
                    title="Buscar"
                    variant="outlined"
                    startIcon={<SearchIcon />}
                    onClick={() => navigate(CASES_GENERAL_INFORMATION)}
                />
            </TitleV1>
            <Grid px="16px">
                <CasesGeneralInformationForm account={account} />
            </Grid>
        </Accordion>
    );
};
